/**
 * Registry of logo (RapidSOS mark) intro animations.
 *
 * To add a new animation:
 *   1. add its id to `MarkAnimation`,
 *   2. add a `.rapidsos-mark--<id>` rule + keyframes in `index.css`,
 *   3. add any per-dot inline vars in `RapidSOSMark.dotStyle`,
 *   4. append an entry to `MARK_ANIMATIONS` so it shows up in Settings.
 */
export type MarkAnimation = 'disco' | 'route' | 'vortex' | 'rain' | 'ripple' | 'glitch';

export interface MarkAnimationOption {
  id: MarkAnimation;
  label: string;
  description: string;
}

export const MARK_ANIMATIONS: MarkAnimationOption[] = [
  {
    id: 'route',
    label: 'Traffic Routing',
    description: 'Dots launch from the center and route out along the grid, green until they park.',
  },
  {
    id: 'disco',
    label: 'Disco Dance',
    description: 'Dots pop in big and rainbow-colored, then shrink to white in a diagonal wipe.',
  },
  {
    id: 'vortex',
    label: 'Vortex',
    description: 'Dots spiral in from the center, spinning up to speed before parking in white.',
  },
  {
    id: 'rain',
    label: 'Matrix Rain',
    description: 'Glowing green streaks cascade down the columns and flicker into white.',
  },
  {
    id: 'ripple',
    label: 'Ripple Pop',
    description: 'Dots burst outward from the center in a springy rainbow ripple.',
  },
  {
    id: 'glitch',
    label: 'Cyber Glitch',
    description:
      'Dots stutter and chromatically split through neon static before locking in white.',
  },
];

export const DEFAULT_MARK_ANIMATION: MarkAnimation = 'rain';
